import $ from 'jquery';

export default function () {
  const selectDefaultOptions = {
    width: 220,
    containerCssClass: 'booking_filter__item',
    minimumResultsForSearch: -1,
  };
  let selectErwachsene = $('#erwachsene');
  let selectUnterkunft = $('#unterkunft');
  selectErwachsene.select2(selectDefaultOptions);
  selectUnterkunft.select2(selectDefaultOptions);
  selectUnterkunft.on('select2:opening , select2:closing', function (e) {
    $('.select2-selection__arrow', $('#unterkunft').parent()).toggleClass('rotate-arrow');
  });
  selectErwachsene.on('select2:opening , select2:closing', function (e) {
    $('.select2-selection__arrow', $('#erwachsene').parent()).toggleClass('rotate-arrow');
  });

  selectUnterkunft.change(function (e) {
    $('.spinner > div').css('display', 'none');
    if ($(e.target).val() === 'ferienwohnung') {
      $('.erwachsene-container').css('display', 'flex');
      $('.booking-date').css('display', 'block');
      $('.booking-filter-button-wrapper').removeClass('hide');
    } else {
      $('.spinner > div').css('display', 'inline-block');
      $('.button--booking_filter').trigger('click');
      $('.erwachsene-container').css('display', 'none');
      $('.booking-date').css('display', 'none');
      $('.booking-filter-button-wrapper').addClass('hide');
    }
  });
  $('b[role="presentation"]').hide();
  $('.select2-selection__arrow').append('<svg width="22" height="10" viewBox="0 0 22 10" xmlns="http://www.w3.org/2000/svg"><path d="M.765 0L0 1.05 11.335 9.3l10.418-8.265-.807-1.02L11.3 7.668z" fill="#000" fill-rule="evenodd"/></svg>');
}
